import { api } from "@monolith/helpers";
const state = {
  activeForm: null,
  editForm: {},
  staffMember: null,
  editing: false,
  roles: {},
  staff: [],
  forms: [],
  isLoaded: false,
  manager: null,
};

const getters = {
  getManager: (state) => state.manager,
  isLoaded: (state) => state.isLoaded,
  getForms: (state) => state.forms,
  getRoles: (state) => state.roles.roles,
  getActiveForm:
    (state) =>
    (id = null) => {
      if (id) {
        return state.forms.find((form) => form._id === id) || null;
      }
      return state.activeForm;
    },
  getStaffMember:
    (state) =>
    (id = null) => {
      if (id) {
        return state.staff.find((staff) => staff.value._id === id) || null;
      }
      return state.staffMember;
    },
  getEditForm: (state) => state.editForm,
  getStaff: (state) => state.staff,
  isEditing: (state) => state.editing,
  getFormsViaRoles: (state) => {
    if (!state.roles.roles) return [];
    return state.roles.roles.map((role) => {
      return { role: role, forms: state.forms.filter((form) => form.roles.includes(role)) };
    });
  },
  getStaffTraining: (state) => (staffID) => {
    let staffMember = state.staff.find((staff) => staff.value._id === staffID);
    return staffMember ? staffMember.value.training || [] : [];
  },
};

const actions = {
  setManager({ commit }, manager) {
    commit("setManagerMutation", manager);
  },

  async updateStaffTraining({ commit, state }, doc) {
    const { staffID, trainingForm } = doc;
    let staffMember = state.staff.find((staff) => staff.value._id === staffID);
    if (staffMember) {
      if (!("training" in staffMember.value)) {
        staffMember.value["training"] = [];
      }
      if ("formId" in trainingForm) {
        let formID = staffMember.value.training.find((entry) => entry.formId === trainingForm.formId);
        if (staffMember.value.training && formID) {
          staffMember.value.training = staffMember.value.training.map((training) => (training.formId === trainingForm.formId ? trainingForm : training));
        } else if (staffMember.value.training) {
          staffMember.value.training.push(trainingForm);
        }
      } else {
        staffMember.value.training.push(trainingForm);
      }
      await api.save_training_doc(staffMember.value);
    }
    const res = await api.get_employees();
    commit("setEmployeesMutation", res);
  },

  setLoaded({ commit }, isLoaded) {
    commit("setLoadedMutation", isLoaded);
  },

  async updateEmployee({ commit }, updatedStaff) {
    await api.save_training_doc(updatedStaff.value);
    const res = await api.get_employees();
    commit("setEmployeesMutation", res);
  },

  async addEmployee({ commit }, staffValue) {
    await api.save_training_doc({ ...staffValue, docType: "employee" });
    const res = await api.get_employees();
    commit("setEmployeesMutation", res);
  },

  setForms({ commit }, forms) {
    commit("setFormsMutation", forms);
  },

  setEmployees({ commit }, staff) {
    commit("setEmployeesMutation", staff);
  },

  setRoles({ commit }, roles) {
    commit("setRolesMutation", roles);
  },

  async createRole({ commit, state }, doc) {
    console.log("Creating role:", doc);
    if (doc.applyToAllStaff) {
      commit("addRoleToAllStaffMutation", doc.name);
    }
    commit("createRoleMutation", doc.name);
    await api.save_training_doc(state.roles);
    const res = await api.get_roles();
    commit("setRolesMutation", res);
  },

  applyRoleToAllStaff({ commit }, roleName) {
    commit("addRoleToAllStaffMutation", roleName);
  },

  editForm({ commit }, { form }) {
    commit("editFormMutation", form);
    commit("editing", true);
  },

  async saveForm({ commit }, doc) {
    await api.save_training_doc(doc);
    const res = await api.get_forms();
    commit("saveFormMutation", res);
  },

  setActiveForm({ commit }, { form, staffMember }) {
    commit("setActiveFormMutation", form);
    commit("setStaffMemberMutation", staffMember);
  },

  editing({ commit }, isEditing) {
    commit("editing", isEditing);
  },
};

const mutations = {
  addRoleToAllStaffMutation(state, roleName) {
    state.staff.forEach((staff) => {
      if (!staff.value.roles.includes(roleName)) {
        staff.value.roles.push(roleName);
        api.save_training_doc(staff.value);
      }
    });
  },

  setLoadedMutation(state, isLoaded) {
    state.isLoaded = isLoaded;
  },

  setFormsMutation(state, forms) {
    forms.map((form) => state.forms.push(form.value));
  },

  setEmployeesMutation(state, staff) {
    state.staff = staff;
  },

  setRolesMutation(state, roles) {
    state.roles = roles;
  },

  createRoleMutation(state, name) {
    state.roles.roles.push(name);
  },

  editFormMutation(state, form) {
    state.editForm = form;
  },

  editing(state, isEditing) {
    state.editing = isEditing;
  },

  saveFormMutation(state, forms) {
    state.forms = forms.map((form) => form.value);
    state.editForm = {};
    state.editing = false;
  },

  setActiveFormMutation(state, form) {
    state.activeForm = form;
  },

  setStaffMemberMutation(state, staff) {
    state.staffMember = staff;
  },

  setManagerMutation(state, manager) {
    state.manager = manager;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
